// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"95":"formulario-de-pedido-cadastro","274":"Home","372":"RouteHomeView"}[chunkId] || chunkId) + "." + {"95":"005a973b","274":"5e406897","372":"9144deee","450":"3010cd6f"}[chunkId] + ".js";
};